function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShield = function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 87.5 87.5"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M45.93 87.5V68.1c12.22 0 22.16-9.94 22.16-22.16h19.4c0 22.92-18.65 41.56-41.56 41.56M0 41.56v-19.4c12.22 0 22.16-9.94 22.16-22.16h19.4c0 22.92-18.65 41.56-41.56 41.56M87.5 41.56C64.58 41.56 45.94 22.91 45.94 0h19.4c0 12.22 9.94 22.16 22.16 22.16v19.4ZM41.56 87.5C18.65 87.5 0 68.85 0 45.94h19.4c0 12.22 9.94 22.16 22.16 22.16v19.4Z",
    style: {
      fill: "#303359"
    }
  }));
};
export default SvgShield;